import React from 'react';
import { CheckCircle, Clock, AlertCircle } from 'lucide-react';

const BookingStatusBreakdown = ({ bookingsAnalytics = {} }) => {
  const byStatus = bookingsAnalytics.by_status || {};

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4 sm:p-6">
      <h3 className="text-sm font-semibold text-gray-900 mb-4">Booking Status</h3>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4 text-green-600" />
            <span className="text-sm text-gray-600">Completed</span>
          </div>
          <span className="text-sm font-semibold text-gray-900">
            {byStatus.completed || 0}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Clock className="w-4 h-4 text-yellow-600" />
            <span className="text-sm text-gray-600">Pending</span>
          </div>
          <span className="text-sm font-semibold text-gray-900">
            {byStatus.pending || 0}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <AlertCircle className="w-4 h-4 text-red-600" />
            <span className="text-sm text-gray-600">Cancelled</span>
          </div>
          <span className="text-sm font-semibold text-gray-900">
            {byStatus.cancelled || 0}
          </span>
        </div>
      </div>
    </div>
  );
};

export default BookingStatusBreakdown;

